<template>
  <div class="stepper">
    <div :class="`badge ${planos || cadastro || pagamento || finalizado ? 'active' : ''}`">
      <i class="fa fa-file-text"></i>
      <span class="info" style="right: -40px">planos</span>
      <div class="bar"></div>
    </div>
    <div :class="`badge ${cadastro || pagamento || finalizado ? 'active' : ''}`">
      <i class="fa fa-user"></i>
      <span class="info" style="right: -50px">cadastro</span>
      <div class="bar"></div>
    </div>
    <div  :class="`badge ${pagamento || finalizado ? 'active' : ''}`">
      <i class="fa fa-credit-card"></i>
      <span  class="info" style="right: -55px">pagamento</span>
      <div class="bar"></div>
    </div>
    <div :class="`badge ${finalizado ? 'active' : ''}`" style="margin-bottom: 0 !important;"  class="badge">
      <i class="fa fa-check"></i>
            <span class="info" style="right: -52px">finalizado</span>

    </div>
  </div>
</template>
<script>
export default {
  name: 'Stepper',
  props: {
    planos: Boolean,
    cadastro: Boolean,
    pagamento: Boolean,
    finalizado: Boolean,
  }
}
</script>
<style  scoped>
.stepper{
  display: flex;
  flex-direction: column;
}


.badge {
  background-color: #747474;
  width: 40px;
  height: 40px;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 60px;
}

.badge span{
  text-transform: uppercase;
  position: absolute;
  text-align: right;
  color: gray;
}

.active {
  background-color: #7b4e93 !important;

}

.active span{
        color: #7b4e93 !important;

}

.bar {
  width: 4px;
  height: 60px;
  position: absolute;
  bottom: -60px;
  left: calc(50% - 2px);
  background-color: gray;
}

i{
  color: white;
}


.active .bar{
    background-color: #7b4e93 !important;
}


@media only screen and (max-width: 700px) {
  .stepper{
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: center;
  }
  .info{
    display: none;
  }
  .badge {
  background-color: #747474;
  width: 40px;
  height: 40px;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 30px !important;
  margin-bottom: 0;
}
.bar {
  width: 40px;
  height: 4px;
  position: absolute;
  top: calc(50% - 2px);
  left: 40px !important;
  background-color: gray;
}
}

</style>